import checkboxInput from './checkboxInput.js';
import datepicker from './datepicker.js';
import fileInput from './fileinput.js';
import format from './format.js';
import formValidation from './formValidation.js';
import httpRequest from './httpRequest.js';
import selectValue from './selectValue.js';
import validation from './validation.js';
import formIntlTelInput from './formIntlTelInput.js';

const selectToggle = {
	/**
	 * Init de selectToggle functies
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function (target) {
		window.app.domStateReady(function () {
			selectToggle.initFunctions(target);
			selectToggle.initEvents();
		});
	},

	/**
	 * Init de selectToggle functies
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	initFunctions: function (target) {
		if (target !== null) {
			var toggleVisibilityElements = target[0].querySelectorAll('[data-select-target-toggle-visibility]');
			toggleVisibilityElements.forEach(function (element) {
				selectToggle.toggleTargetVisibility(element);
			});

			var toggleReadonlyElements = target[0].querySelectorAll('[data-select-target-toggle-readonly]');
			toggleReadonlyElements.forEach(function (element) {
				selectToggle.toggleTargetReadonly(element);
			});

			var toggleDisabledElements = target[0].querySelectorAll('[data-select-target-toggle-disabled]');
			toggleDisabledElements.forEach(function (element) {
				selectToggle.toggleTargetDisabled(element);
			});

			var toggleValueElements = target[0].querySelectorAll('[data-select-target-toggle-value]');
			toggleValueElements.forEach(function (element) {
				selectToggle.toggleTargetValue(element);
			});

			var toggleAttributeElements = target[0].querySelectorAll('[data-select-target-toggle-attribute]');
			toggleAttributeElements.forEach(function (element) {
				selectToggle.toggleTargetAttribute(element);
			});

			var toggleHtmlElements = target[0].querySelectorAll('[data-select-target-toggle-html]');
			toggleHtmlElements.forEach(function (element) {
				selectToggle.toggleTargetHTML(element);
			});
		}
	},

	/**
	 * Init de selectToggle events
	 *
	 * @returns {void}
	 */
	initEvents: function () {
		$('body').on('change', '[data-select-target-toggle-visibility]', function (event) {
			selectToggle.toggleTargetVisibility(event.target);
		});

		$('body').on('change', '[data-select-target-toggle-disabled]', function (event) {
			selectToggle.toggleTargetDisabled(event.target);
		});

		$('body').on('change', '[data-select-target-toggle-readonly]', function (event) {
			selectToggle.toggleTargetReadonly(event.target);
		});

		$('body').on('change', '[data-select-target-toggle-value]', function (event) {
			selectToggle.toggleTargetValue(event.target);
		});

		$('body').on('change', '[data-select-target-toggle-attribute]', function (event) {
			selectToggle.toggleTargetAttribute(event.target);
		});

		$('body').on('change', '[data-select-target-toggle-html]', function (event) {
			selectToggle.toggleTargetHTML(event.target);
		});
	},

	/**
	 * Toon of verberg elementen opgegeven in data attribute
	 *
	 * @param {object} element
	 * @returns {void}
	 */
	toggleTargetVisibility: function (element) {
		var selectedOption = element.options[element.selectedIndex] || false;

		if (selectedOption !== false) {
			var targetString = selectedOption.getAttribute('data-toggle-visibility-target') || false;
			var targetArray = JSON.parse('[' + targetString + ']');
			if (targetString !== false) {
				for (var i = 0; i < targetArray.length; i++) {
					var target = targetArray[i][0] || false;
					var state = targetArray[i][1] || false;
					var required = true;
					if (typeof targetArray[i][2] !== 'undefined') {
						required = targetArray[i][2];
					}
					var targetElements = document.querySelectorAll(target);
					var targetElement = document.querySelectorAll(target)[0];
					if (typeof targetElement !== 'undefined') {
						if (selectToggle.isFormElement(targetElement)) {
							selectToggle.toggleFormGroup(targetElement, state, required);
						} else {
							selectToggle.toggleElementVisibility(targetElements, state);
						}
					}
				}
			}
		}
	},

	/**
	 * Toon of verberg elementen opgegeven in data attribute
	 *
	 * @param {object} element
	 * @returns {void}
	 */
	toggleTargetDisabled: function (element) {
		var selectedOption = element.options[element.selectedIndex] || false;
		var targetString = selectedOption.getAttribute('data-toggle-disabled-target') || false;
		var targetArray = JSON.parse('[' + targetString + ']');
		if (targetString !== false) {
			for (var i = 0; i < targetArray.length; i++) {
				var target = targetArray[i][0] || false;
				var state = targetArray[i][1] || false;
				var targetElements = document.querySelectorAll(target);
				if (typeof targetElements !== 'undefined') {
					targetElements.forEach(function (targetElement) {
						targetElement.removeAttribute('disabled');
						if (state == 'disabled') {
							targetElement.setAttribute('disabled', true);
							if (targetElement.parentNode.nodeName == 'SELECT') {
								targetElement.parentNode.value = '';
							}
						}
					});
				}
			}
		}
	},

	/**
	 * Toon of verberg elementen opgegeven in data attribute
	 *
	 * @param {object} element
	 * @returns {void}
	 */
	toggleTargetReadonly: function (element) {
		var selectedOption = element.options[element.selectedIndex] || false;
		if (selectedOption !== false) {
			var targetString = selectedOption.getAttribute('data-toggle-readonly-target') || false;
			var targetArray = JSON.parse('[' + targetString + ']');
			if (targetString !== false) {
				for (var i = 0; i < targetArray.length; i++) {
					var target = targetArray[i][0] || false;
					var state = targetArray[i][1] || false;
					var targetElement = document.querySelectorAll(target)[0];
					if (typeof targetElement !== 'undefined') {
						targetElement.removeAttribute('readonly');
						if (state == 'readonly') {
							targetElement.setAttribute('readonly', true);
							if (targetElement.parentNode.nodeName == 'SELECT') {
								targetElement.parentNode.value = '';
							}
						}
					}
				}
			}
		}
	},

	/**
	 * Toon of verberg elementen opgegeven in data attribute
	 *
	 * @param {object} element
	 * @returns {void}
	 */
	toggleTargetValue: function (element) {
		var selectedOption = element.options[element.selectedIndex] || false;
		if (selectedOption !== false) {
			var targetString = selectedOption.getAttribute('data-toggle-value-target') || false;
			var targetArray = JSON.parse('[' + targetString + ']');
			if (targetString !== false) {
				for (var i = 0; i < targetArray.length; i++) {
					var target = targetArray[i][0] || false;
					var value = targetArray[i][1] || '';
					var targetElement = document.querySelectorAll(target)[0];
					if (typeof targetElement !== 'undefined') {
						targetElement.value = value;
					}
				}
			}
		}
	},

	/**
	 * Toon of verberg elementen opgegeven in data attribute
	 *
	 * @param {object} element
	 * @param {string} target
	 * @param {bool} required
	 * @param {bool} reset
	 * @returns {void}
	 */
	toggleFormGroup: function (element, state, required, reset = false) {
		var target = element.closest('.form-group');
		target.classList.add('d-none');
		element.setAttribute('disabled', 'true');
		validation.removeRequired(element);
		if (reset == true) {
			element.value = '';
		}
		if (state == 'visible') {
			target.classList.remove('d-none');
			element.removeAttribute('disabled');
			if (required) {
				validation.addRequired(element);
			}
		}
	},

	/**
	 * Toon of verberg elementen opgegeven in data attribute
	 *
	 * @param {object} element
	 * @param {string} target
	 * @returns {void}
	 */
	toggleTargetHTML: function (target) {
		var targetElementName = target.getAttribute('data-select-target-toggle-html-target') || null;
		var targetElement = document.querySelector(targetElementName);
		var vars = target.options[target.selectedIndex].value;
		var group = target.closest('.form-group');
		var form = target.closest('form');
		var spinner = group.querySelector('[data-form-group-spinner]');
		if (typeof vars !== 'undefined' && vars !== '') {
			target.setAttribute('disabled', true);
			spinner.classList.remove('d-none');
			var dataPath = window.app.ajaxPath + target.getAttribute('data-select-target-toggle-html-path') + vars;
			httpRequest.send('GET', dataPath, function (data) {
				targetElement.innerHTML = data;
				fileInput.initFilepond(form);
				setTimeout(function () {
					checkboxInput.init(form);
					selectValue.init(form.parentElement);
					datepicker.init();
					formValidation.initBlurEvent(form.parentElement);
					formIntlTelInput.init(form);
					format.init(form);
					spinner.classList.add('d-none');
					target.removeAttribute('disabled');
				}, 100);
			});
		} else {
			targetElement.innerHTML = '';
		}
	},

	/**
	 * Set data attribute van element
	 *
	 * @param {object} element
	 * @returns {void}
	 */
	toggleTargetAttribute: function (element) {
		var selectedOption = element.options[element.selectedIndex] || false;
		var targetString = selectedOption.getAttribute('data-toggle-attribute-target') || false;
		var targetArray = JSON.parse('[' + targetString + ']');
		if (targetString !== false) {
			for (var i = 0; i < targetArray.length; i++) {
				var target = targetArray[i][0] || false;
				var attribute = targetArray[i][1] || '';
				var value = targetArray[i][2] || '';
				var targetElement = document.querySelectorAll(target)[0];
				if (typeof targetElement !== 'undefined') {
					targetElement.setAttribute(attribute, value);
				}
			}
		}
	},

	/**
	 * Toon of verberg elementen opgegeven in data attribute
	 *
	 * @param {object} element
	 * @param {string} target
	 * @returns {void}
	 */
	toggleElementVisibility: function (elements, state) {
		elements.forEach(function (element) {
			element.classList.add('d-none');
			if (state == 'visible') {
				element.classList.remove('d-none');
			}
		});
	},

	/**
	 * Check of element een form element betreft
	 *
	 * @param {object} element
	 * @param {string} target
	 * @returns {void}
	 */
	isFormElement: function (element) {
		var isFormElement = false;
		if (element.nodeName == 'INPUT' || element.nodeName == 'SELECT') {
			isFormElement = true;
		}
		return isFormElement;
	},
};

export default selectToggle;
